/** Normalize backend/cookie session id fields into a single `sessionUniqueKey`. */
export function resolveSessionIdFromAuthResponse(
  data: { sessionUniqueKey?: string; sessionUniqueId?: string } | null | undefined
): string | undefined {
  if (!data) return undefined
  const key = data.sessionUniqueKey ?? data.sessionUniqueId
  return String(key ?? '').trim() || undefined
}
